<template>
  <div class="text-options-setting-dialog" :class="isBigScreen ? 'bc-setting' : ''">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')" title="外观" name="2">
          <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
            <div class="verticallyCenter">
              <slider-and-input
                v-if="!logicTextDynamicId"
                :value.sync="opacity"
                title="透明度"
                :sliderMax="100"
                suffix="%"
              />
              <slider-and-input
                v-else
                :value.sync="logicTextDynamicStyle.opacity"
                title="透明度"
                :sliderMax="100"
                suffix="%"
              />
            </div>
            <widthAndSizeAndZindex
              :options="options"
              :ids="ids"
              showSetItem="rotate"
              class="mt16"
              v-if="request_prefix !== 'bigScreen'"
            />
            <cx-background :background.sync="background" class="mt16" />
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <!-- <el-checkbox @change="checkboxHandle(3)">阴影</el-checkbox> -->
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              ></box-shadow>
            </div>
            <!--            <div v-if="!noCacheComponent" class="content-item verticallyCenter mb16 mt16">-->
            <!--              <el-input-->
            <!--                style="width: 100%"-->
            <!--                type="textarea"-->
            <!--                rows="2"-->
            <!--                v-model="content"-->
            <!--                placeholder="请输入文本内容"-->
            <!--              ></el-input>-->
            <!--            </div>-->
            <div class="content-item mt16 verticallyCenter mb16">
              <span class="mr16">溢出</span>
              <text-setting-overflow class="flex1" :overFlowType.sync="textOverFlowType"></text-setting-overflow>
            </div>
            <div class="content-item verticallyCenter">
              <el-checkbox v-model="contentHasLimit">字数限制</el-checkbox>
            </div>
            <div v-show="contentHasLimit" class="content-item card mt16">
              <div class="content-item fs14 verticallyCenter count-limit-item">
                <span class="mr16">超出</span>
                <single-input
                  class="size-inp mr8"
                  style="width: 90px; height: 32px"
                  :value.sync="textLimitLines"
                  inputSuffixs="行"
                />
                <span>隐藏</span>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')" title="边距" name="3">
          <cx-padding
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
            :paddingTypeFlag.sync="textPaddingTypeFlag"
            :padding.sync="padding"
            :paddingTop.sync="paddingTop"
            :paddingRight.sync="paddingRight"
            :paddingBottom.sync="paddingBottom"
            :paddingLeft.sync="paddingLeft"
            :sliderMax="paddingMax"
          />
          <!--          <div class="border-radius-header">-->
          <!--            <label>内边距</label>-->
          <!--            <div class="grid-type-btn floatRight mb16" :class="request_prefix !== 'bigScreen' ? 'normal-pad-type' : ''">-->
          <!--              <span-->
          <!--                class="icon-portal-padding-around pointer"-->
          <!--                :class="textPaddingTypeFlag == 1 ? 'select' : ''"-->
          <!--                @click="changeTextPaddingType(1)"-->
          <!--              ></span>-->
          <!--              <span-->
          <!--                class="icon-portal-padding pointer"-->
          <!--                :class="textPaddingTypeFlag == 2 ? 'select' : ''"-->
          <!--                @click="changeTextPaddingType(2)"-->
          <!--              ></span>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div v-if="textPaddingTypeFlag == 1">-->
          <!--            <slider-and-input :value.sync="padding" :sliderMax="paddingMax" suffix="px" />-->
          <!--          </div>-->
          <!--          <div v-if="textPaddingTypeFlag == 2" class="setting-item-grid" :class="isBigScreen ? '' : 'home'">-->
          <!--            <slider-and-input-->
          <!--              :value.sync="paddingTop"-->
          <!--              :sliderMax="paddingMax"-->
          <!--              suffix="px"-->
          <!--              class="mt16"-->
          <!--              className="grid_edge_2"-->
          <!--            />-->
          <!--            <slider-and-input-->
          <!--              :value.sync="paddingBottom"-->
          <!--              :sliderMax="paddingMax"-->
          <!--              suffix="px"-->
          <!--              class="mt16"-->
          <!--              className="grid_edge_4"-->
          <!--            />-->
          <!--            <slider-and-input-->
          <!--              :value.sync="paddingRight"-->
          <!--              :sliderMax="paddingMax"-->
          <!--              suffix="px"-->
          <!--              class="mt16"-->
          <!--              className="grid_edge_3"-->
          <!--            />-->
          <!--            <slider-and-input-->
          <!--              :value.sync="paddingLeft"-->
          <!--              :sliderMax="paddingMax"-->
          <!--              suffix="px"-->
          <!--              class="mt16"-->
          <!--              className="grid_edge_1"-->
          <!--            />-->
          <!--          </div>-->
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
          title="文字"
          name="4"
        >
          <!--          <div-->
          <!--            class="setting-item clearFloat mb8"-->
          <!--            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"-->
          <!--          >-->
          <!-- 字体和颜色/字重和字号 -->
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
            <div v-if="!logicTextDynamicId">
              <text-setting-complex-update
                v-if="!logicTextDynamicId"
                class="mb16"
                :fontFamily.sync="fontFamily"
                :fontSize.sync="fontSize"
                :fontWeight.sync="fontWeight"
                :fontStyle.sync="fontStyle"
                :textDecoration.sync="textDecoration"
                :lineHeight.sync="lineHeight"
                :letterSpacing.sync="letterSpacing"
                :activeArrangement.sync="activeArrangement"
                :writingMode.sync="writingMode"
                :textAlign.sync="textAlign"
                :activeArrangementOrder.sync="activeArrangementOrder"
                :lineHeightType.sync="lineHeightType"
                :letterSpacingType.sync="letterSpacingType"
                :showColorSet="false"
                :options="options"
              />
              <div class="mt16">
                <el-radio-group v-model="colorType" style="height: 20px">
                  <el-radio label="纯色">纯色</el-radio>
                  <el-radio label="线性渐变">线性渐变</el-radio>
                </el-radio-group>
              </div>
              <color-picker-theme-color
                v-if="colorType === '纯色'"
                :isThemeColor.sync="textIsThemeColor"
                :color.sync="color"
                class="custom-text-bg mt16"
              >
              </color-picker-theme-color>
              <div v-if="colorType === '线性渐变'" class="mt16">
                <span class="mr16 fs14">开始颜色</span>
                <div class="color-picker-container custom-text-bg mt8">
                  <el-color-picker
                    class=""
                    v-model="startColor"
                    color-format="rgb"
                    :show-alpha="true"
                  ></el-color-picker>
                  <span class="floatLeft color-text mr8">{{ startColor }}</span>
                </div>
              </div>
              <div v-if="colorType === '线性渐变'" class="mt16">
                <span class="mr16 fs14">结束颜色</span>
                <div class="color-picker-container custom-text-bg mt8">
                  <el-color-picker class="" v-model="endColor" color-format="rgb" :show-alpha="true"></el-color-picker>
                  <span class="floatLeft color-text mr8">{{ endColor }}</span>
                </div>
              </div>
              <div v-if="colorType !== '纯色'" class="mt16">
                <div class="slider-input-container paddingl0">
                  <span class="mr16 fs14">渐变角度</span>
                  <el-slider
                    :show-tooltip="false"
                    class="mr16"
                    style="width: 80px; height: 4px"
                    v-model="colorlinearGradientAngle"
                    :max="360"
                    :min="0"
                  ></el-slider>
                  <single-input
                    style="width: 60px; height: 28px"
                    :max="360"
                    :value.sync="colorlinearGradientAngle"
                    inputSuffixs="度"
                  />
                </div>
              </div>
            </div>
            <div v-else>
              <text-setting-complex-update
                class="mb16"
                @change="changeLogicTextDynamicStyleHandle"
                :fontFamily.sync="logicTextDynamicStyle.fontFamily"
                :fontSize.sync="logicTextDynamicStyle.fontSize"
                :fontWeight.sync="logicTextDynamicStyle.fontWeight"
                :fontStyle.sync="logicTextDynamicStyle.fontStyle"
                :textDecoration.sync="logicTextDynamicStyle.textDecoration"
                :lineHeight.sync="logicTextDynamicStyle.lineHeight"
                :letterSpacing.sync="logicTextDynamicStyle.letterSpacing"
                :activeArrangement.sync="logicTextDynamicStyle.activeArrangement"
                :writingMode.sync="logicTextDynamicStyle.writingMode"
                :textAlign.sync="logicTextDynamicStyle.textAlign"
                :activeArrangementOrder.sync="logicTextDynamicStyle.activeArrangementOrder"
                :showColorSet="false"
              />
              <!-- <text-setting-complex
                class="mb16"
                @change="changeLogicTextDynamicStyleHandle"
                :fontFamily.sync="logicTextDynamicStyle.fontFamily"
                :fontSize.sync="logicTextDynamicStyle.fontSize"
                :fontWeight.sync="logicTextDynamicStyle.fontWeight"
                :fontStyle.sync="logicTextDynamicStyle.fontStyle"
                :textDecoration.sync="logicTextDynamicStyle.textDecoration"
                :lineHeight.sync="logicTextDynamicStyle.lineHeight"
                :letterSpacing.sync="logicTextDynamicStyle.letterSpacing"
                :activeArrangement.sync="logicTextDynamicStyle.activeArrangement"
                :writingMode.sync="logicTextDynamicStyle.writingMode"
                :textAlign.sync="logicTextDynamicStyle.textAlign"
                :activeArrangementOrder.sync="logicTextDynamicStyle.activeArrangementOrder"
              /> -->
              <div class="mt16">
                <el-radio-group
                  @change="changeLogicTextDynamicStyleHandle({ type: 'colorType', value: $event })"
                  v-model="logicTextDynamicStyle.colorType"
                  style="height: 20px"
                >
                  <el-radio label="纯色">纯色</el-radio>
                  <el-radio label="线性渐变">线性渐变</el-radio>
                </el-radio-group>
              </div>
              <color-picker-theme-color
                v-if="logicTextDynamicStyle.colorType === '纯色'"
                @change="changeLogicTextDynamicStyleHandle"
                :isThemeColor.sync="logicTextDynamicStyle.textIsThemeColor"
                :color.sync="logicTextDynamicStyle.color"
                class="custom-text-bg mt16"
              >
              </color-picker-theme-color>
              <div v-if="logicTextDynamicStyle.colorType === '线性渐变'" class="mt16">
                <span class="mr16 fs14">开始颜色</span>
                <div class="color-picker-container custom-text-bg mt8">
                  <el-color-picker
                    @change="changeLogicTextDynamicStyleHandle({ type: 'startColor', value: $event })"
                    class=""
                    v-model="logicTextDynamicStyle.startColor"
                    color-format="rgb"
                    :show-alpha="true"
                  ></el-color-picker>
                  <span class="floatLeft color-text mr8">{{ logicTextDynamicStyle.startColor }}</span>
                </div>
              </div>
              <div v-if="logicTextDynamicStyle.colorType === '线性渐变'" class="mt16">
                <span class="mr16 fs14">结束颜色</span>
                <div class="color-picker-container custom-text-bg mt8">
                  <el-color-picker
                    @change="changeLogicTextDynamicStyleHandle({ type: 'endColor', value: $event })"
                    class=""
                    v-model="logicTextDynamicStyle.endColor"
                    color-format="rgb"
                    :show-alpha="true"
                  ></el-color-picker>
                  <span class="floatLeft color-text mr8">{{ logicTextDynamicStyle.endColor }}</span>
                </div>
              </div>
              <div v-if="logicTextDynamicStyle.colorType !== '纯色'" class="mt16">
                <div class="slider-input-container paddingl0">
                  <span class="mr16 fs14">渐变角度</span>
                  <el-slider
                    @change="changeLogicTextDynamicStyleHandle({ type: 'colorlinearGradientAngle', value: $event })"
                    :show-tooltip="false"
                    class="mr16"
                    style="width: 96px; height: 4px"
                    v-model="logicTextDynamicStyle.colorlinearGradientAngle"
                    :max="360"
                    :min="0"
                  ></el-slider>
                  <single-input
                    @change="changeLogicTextDynamicStyleHandle({ type: 'colorlinearGradientAngle', value: $event })"
                    style="width: 60px; height: 28px"
                    :value.sync="logicTextDynamicStyle.colorlinearGradientAngle"
                    inputSuffixs="度"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')" title="边框" name="5">
          <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')">
<!--            <div v-show="contentHasLimit" class="content-item card mt16">-->
<!--              <div class="content-item fs14 verticallyCenter count-limit-item">-->
<!--                <span class="mr16">超出</span>-->
<!--                <single-input-->
<!--                  class="size-inp mr8"-->
<!--                  style="width: 90px; height: 32px"-->
<!--                  :value.sync="textLimitLines"-->
<!--                  inputSuffixs="行"-->
<!--                />-->
<!--                <span>隐藏</span>-->
<!--              </div>-->
<!--            </div>-->
            <div class="content-item mb16">
              <div class="border-radius-header mb24">
                <span>圆角</span>
                <div class="border-radius-btn">
                  <span
                    class="icon-portal-adjustment1"
                    :class="borderTypeFlag == 2 ? 'select' : ''"
                    @click="changeBorderRadiusType(2)"
                  ></span>
                  <span
                    class="icon-portal-full-screen1"
                    :class="borderTypeFlag == 1 ? 'select' : ''"
                    @click="changeBorderRadiusType(1)"
                  ></span>
                </div>
              </div>
              <div v-if="borderTypeFlag == 1">
                <slider-and-input
                  :value.sync="borderTopLeftRadius"
                  :sliderMax="paddingMax"
                  suffix="px"
                  class="mt16"
                  className="radius_bg_1"
                />
                <slider-and-input
                  :value.sync="borderTopRightRadius"
                  :sliderMax="paddingMax"
                  suffix="px"
                  class="mt16"
                  className="radius_bg_2"
                />
                <slider-and-input
                  :value.sync="borderBottomRightRadius"
                  :sliderMax="paddingMax"
                  suffix="px"
                  class="mt16"
                  className="radius_bg_3"
                />
                <slider-and-input
                  :value.sync="borderBottomLeftRadius"
                  :sliderMax="paddingMax"
                  suffix="px"
                  class="mt16"
                  className="radius_bg_4"
                />
              </div>
              <div v-else class="verticallyCenter">
                <slider-and-input :value.sync="borderRadius" :sliderMax="paddingMax" suffix="px" />
              </div>
            </div>
            <div>
              <div class="mb16">边框</div>
              <cx-border
                :borderWidth.sync="borderWidth"
                :borderStyle.sync="borderStyle"
                :borderColor.sync="borderColor"
                :borderIsThemeColor.sync="borderIsThemeColor"
              />
            </div>
          </div>
        </el-collapse-item>

        <el-collapse-item
          v-if="request_prefix === 'bigScreen'"
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
          title="动画设置"
          name="6"
        >
          <big-screen-animate-set
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')"
          ></big-screen-animate-set>
        </el-collapse-item>
        <el-collapse-item v-show="$store.state.states.showPluginSetting" title="插件" name="7">
          <div class="setting-item">
            <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import TextSettingOverflow from "modules/components/textSettingOverflow"
import { parseAST } from "utils/parseDomAst/index"
import { withMethodsHistoryCombine } from "utils/revork"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
export default withMethodsHistoryCombine({
  name: "text-options-data",
  components: {
    TextSettingComplex,
    TextSettingOverflow,
    widthAndSizeAndZindex,
    controlWidthAndSizeAndZindex,
    bigScreenAnimateSet: () => import("components/stageComponents/toolbar/bigScreen-animate-set.vue"),
    elementPluginSetting
  },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2", "3", "7"],
      collapseActiveNames: ["1", "2", "3", "7"],
      allCollapseNames: ["4", "5", "6"],
      hoverOpt: [],
      this1: this,
      activeType: 1,
      sliderMax: 360,
      paddingMax: 200,
      // bgTypes: [
      //   // {
      //   //   name: "主题色"
      //   // },
      //   {
      //     name: "自定义"
      //   }
      // ],
      textPaddingTypeFlag: 1,
      logicTextDynamicStyle: {
        opacity: "",
        fontFamily: "",
        fontSize: "",
        fontWeight: "",
        fontStyle: "",
        textDecoration: "",
        lineHeight: "",
        letterSpacing: "",
        activeArrangement: "",
        writingMode: "",
        textAlign: "",
        activeArrangementOrder: "",
        textIsThemeColor: "",
        colorType: "",
        color: "",
        startColor: "",
        endColor: "",
        colorlinearGradientAngle: ""
      }
      // textOverFlowType: "visible"
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  },
  watch: {
    logicTextDynamicId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.initLogicTextDynamicStyleHandle()
        }
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    logicTextDynamicId() {
      return this.$store.state.states.logicTextDynamicId
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    content: {
      get() {
        return this.options.content
      },

      set(newVal) {
        this.$changeOptionsEV(newVal, "content", false)
      }
    },
    opacity: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowColor", "boxShadowColor", ["rgba(255,255,255,1)"])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        // return this.options.boxShadowH || 0
        return this.checkAndSetPrimaryVal(this.options, "boxShadowH", "boxShadowH", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        // return this.options.boxShadowV || 0
        return this.checkAndSetPrimaryVal(this.options, "boxShadowV", "boxShadowV", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        // return this.options.boxShadowBlur || 0
        return this.checkAndSetPrimaryVal(this.options, "boxShadowBlur", "boxShadowBlur", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        // return this.options.boxShadowSpread || 0
        return this.checkAndSetPrimaryVal(this.options, "boxShadowSpread", "boxShadowSpread", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    textOverFlowType: {
      get() {
        // return this.options.textOverFlowType || "visible"
        return this.checkAndSetPrimaryVal(this.options, "textOverFlowType", "textOverFlowType", "visible")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textOverFlowType", false)
      }
    },
    textIsThemeColor: {
      get() {
        // return this.options.textIsThemeColor || false
        return this.checkAndSetPrimaryVal(this.options, "textIsThemeColor", "textIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    textLimitLines: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "textLimitLines", "textLimitLines", 1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitLines", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false)
      }
    },
    activeRect() {
      // this.options();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    activeArrangement() {
      return this.options.textAlign
    },
    colorlinearGradientAngle: {
      get() {
        return this.options.colorlinearGradientAngle || 90
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "colorlinearGradientAngle", false)
      }
    },
    bgType: {
      get() {
        return this.options.bgType || "主题色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    fontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "fontFamily", "fontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "fontSize", "fontSize", 14)
      },
      set(newVal) {
        this.lineHeight = newVal > this.lineHeight ? newVal : this.lineHeight
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "fontWeight", "fontWeight", "400")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    color: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "color", "color", "rgba(0, 0, 0, 0.8)")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    colorType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "colorType", "colorType", "纯色")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "colorType", false)
      }
    },
    startColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "startColor", "startColor", "rgba(0, 0, 0, 0.8)")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "startColor", false)
      }
    },
    endColor: {
      get() {
        return this.options.endColor
        return this.checkAndSetPrimaryVal(this.options, "endColor", "endColor", "rgba(0, 0, 0, 0.8)")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "endColor", false)
      }
    },
    textAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "textAlign", "textAlign", "left")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    fontStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "fontStyle", "fontStyle", "normal")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    lineHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lineHeight", "lineHeight", 34)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    letterSpacing: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "letterSpacing", "letterSpacing", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacing", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-logicText-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    writingMode: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "writingMode", "writingMode", "horizontal-tb")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    textDecoration: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "textDecoration", "textDecoration", "none")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    borderTypeFlag: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", 2)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderRadius", "borderRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          ["borderRadius", "borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopLeftRadius", "borderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV([newVal, newVal], ["borderRadius", "borderTopLeftRadius"], false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopRightRadius", "borderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomRightRadius", "borderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomLeftRadius", "borderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    // 描边
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderColor", "borderColor", "rgba(255,255,255,0)")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderStyle", "borderStyle", "solid")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    lineHeightType: {
      get() {
        return this.options.lineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
  },
  methods: {
    changeTextPaddingType(value) {
      this.textPaddingTypeFlag = value
    },
    changeBorderRadiusType(value) {
      this.borderTypeFlag = value
      let borderRadius = this.borderRadius
      this.$changeOptionsEV(borderRadius, "borderTopLeftRadius", false)
      this.$changeOptionsEV(borderRadius, "borderTopRightRadius", false)
      this.$changeOptionsEV(borderRadius, "borderBottomRightRadius", false)
      this.$changeOptionsEV(borderRadius, "borderBottomLeftRadius", false)
    },

    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    // 初始化逻辑文本中变量和动态数据样式
    initLogicTextDynamicStyleHandle() {
      const self = this
      Object.keys(self.logicTextDynamicStyle).forEach(item => {
        switch (item) {
          case "fontSize":
            this.logicTextDynamicStyle[item] = document.getElementById(self.logicTextDynamicId).style[item]
              ? parseFloat(document.getElementById(self.logicTextDynamicId).style[item])
              : self[item]
            break
          case "lineHeight":
            this.logicTextDynamicStyle[item] = document.getElementById(self.logicTextDynamicId).style[item]
              ? parseFloat(document.getElementById(self.logicTextDynamicId).style[item])
              : self[item]
            break
          case "opacity":
            this.logicTextDynamicStyle[item] = document.getElementById(self.logicTextDynamicId).style[item]
              ? parseFloat(document.getElementById(self.logicTextDynamicId).style[item]) * 100
              : self[item]
            break
          default:
            this.logicTextDynamicStyle[item] = document.getElementById(self.logicTextDynamicId).style[item]
              ? document.getElementById(self.logicTextDynamicId).style[item]
              : self[item]
            break
        }
      })
    },
    // 改变逻辑文本中变量和动态数据样式
    changeLogicTextDynamicStyleHandle($event) {
      if (this.logicTextDynamicId) {
        switch ($event.type) {
          case "fontSize":
            document.getElementById(this.logicTextDynamicId).style[$event.type] = $event.value + "px"
            break
          case "lineHeight":
            document.getElementById(this.logicTextDynamicId).style[$event.type] = $event.value + "px"
            break
          case "opacity":
            document.getElementById(this.logicTextDynamicId).style[$event.type] = $event.value + "%"
            break
          default:
            document.getElementById(this.logicTextDynamicId).style[$event.type] = $event.value
            break
        }
        const parentDom = document.getElementById("logicTextContent-" + this.ids.container_id + "-" + this.ids.rect_id)
        const ast = parseAST(parentDom.innerHTML)
        this.$changeOptionsEV(ast, "ast", false)
      }
      // if (this.logicTextDynamicId) {
      //   document.getElementById(this.logicTextDynamicId).style.fontSize = value + 'px'
      //   // 更新ast
      //   const parentDom = document.getElementById('logicTextContent-' + this.ids.rect_id)
      //   const ast = parseAST(parentDom.innerHTML)
      //   this.$changeOptionsEV(ast, "ast", false)
      // } else {
      //   this.$changeOptionsEV(value, attrs, false)
      // }
    }
  }
})
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
.color-picker-container.custom-text-bg {
  // width: calc(100% - 40px);
  // display: inline-block;
  // vertical-align: middle;
}
.paddingl0 {
  padding-left: 0;
}

::v-deep .boxshadow-wrap {
  z-index: 1002;
}
::v-deep .boxshadow-wrap .ml24 {
  margin-left: 2px;
  margin-right: 10px;
}
::v-deep.font-arrangement-btn {
  background: #f0f0f0;
}
.bc-setting ::v-deep.font-arrangement-btn {
  border: none;
}
</style>
